<template>
  <div class="flex items-center gap-2">
    <button
      type="button"
      class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md border transition-colors"
      :class="disabled || exporting
        ? 'border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'
        : 'border-red-200 text-red-700 bg-red-50 hover:bg-red-100'"
      :disabled="disabled || exporting"
      @click="$emit('pdf')"
    >
      <i class="fa-solid fa-file-pdf mr-1.5"></i>
      PDF
    </button>
    <button
      type="button"
      class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md border transition-colors"
      :class="disabled || exporting
        ? 'border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'
        : 'border-green-200 text-green-800 bg-green-50 hover:bg-green-100'"
      :disabled="disabled || exporting"
      @click="$emit('xls')"
    >
      <i class="fa-solid fa-file-excel mr-1.5"></i>
      Excel
    </button>
  </div>
</template>

<script>
export default {
  name: 'ScheduleExportButtons',
  props: {
    disabled: { type: Boolean, default: true },
    exporting: { type: Boolean, default: false },
  },
  emits: ['pdf', 'xls'],
}
</script>
